import { Template } from "../../template/Template.js";
import { prefillTemplate } from "../../template/prefillTemplate.js";
import { INCOMING_NO_VAT_INVOICE } from "./IncomingNoVatInvoice.js";

export const APPLE_LIGHTROOM_INVOICE: Template = prefillTemplate(
  INCOMING_NO_VAT_INVOICE,
  "7826d86e-24db-4b57-bba7-c8873cf5b34e",
  "Apple Lightroom arve",
  [
    {
      name: "Title",
      value: "Apple Lightroom arve"
    }
  ],
  [{ name: "Expense amount", value: "5.49" }]
);
